var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderArrowPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 67,
    viewBox: "0 0 44 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2125",
    "data-name": "Rectangle 2125",
    width: 44,
    height: 67,
    transform: "translate(1322 1339)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "slider-arrow-prev",
    transform: "translate(1366 1406) rotate(180)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2050",
    "data-name": "Group 2050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    transform: "translate(1328 1342)",
    fill: "none",
    stroke: "#005F74",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "slider-next-icon",
    transform: "translate(1341.14 1367.027)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x2: 17.221,
    transform: "translate(0 5.74)",
    fill: "none",
    stroke: "#005F74",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x2: 5.74,
    y2: 5.74,
    transform: "translate(11.481)",
    fill: "none",
    stroke: "#005F74",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    y1: 5.74,
    x2: 5.74,
    transform: "translate(11.481 5.74)",
    fill: "none",
    stroke: "#005F74",
    strokeLinecap: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrowPrev);
export default __webpack_public_path__ + "static/media/slider-arrow-prev.7f9af7f8a0cf6fc613b41ef74e99794c.svg";
export { ForwardRef as ReactComponent };